import { api } from "../common/http";

const InviteApi = {
  validate: async (token) => {
    if (!token) throw new Error("Missing invite token.");
    const res = await api.get("/public/invites/validate", {
      params: { token },
      skipAuth: true,
    });
    return res.data;
  },
  complete: async (payload) => {
    const res = await api.post("/public/invites/complete", payload, {
      skipAuth: true,
    });
    return res.data;
  },
};

export default InviteApi;
